// eslint-disable-next-line no-restricted-imports
import {
  matchPath,
  // eslint-disable-next-line no-restricted-imports
  generatePath as reactRouterDomGeneratePath,
} from "react-router-dom";

export const Page = {
  DEFAULT: "",
  HOME: "/",
  LOGIN: "/login",
  LOGIN_WITH_TOKEN: "/login-with-token",
  EDIT_COMPANY: "/super-admin/:companyId/edit",
  VENDORS: "/vendors",
  ADD_VENDOR: "/vendors/add-new",
  VENDOR_FORMS: "/vendor-forms",
  VENDOR_FORM_DETAILS: "/vendor-forms/:intakeSubmissionId",
  VENDOR_FORM_DETAILS_TAB: "/vendor-forms/:intakeSubmissionId/:tab",
  VENDOR_FORM_EDIT: "/vendor-forms/:intakeSubmissionId/edit",
  VENDOR_DETAILS: "/vendors/:vendorId",
  VENDOR_DETAILS_SERVICES: "/vendors/:vendorId/services",
  VENDOR_DETAILS_TAB: "/vendors/:vendorId/:tab",
  EDIT_VENDOR: "/vendors/:vendorId/edit",
  SERVICES: "/services",
  ADD_SERVICE: "/services/add-new",
  SERVICE_DETAILS: "/services/:serviceId",
  EDIT_SERVICE: "/services/:serviceId/edit",
  SOURCING_FORMS: "/sourcing/forms",
  SOURCING_FORM_DETAILS: "/sourcing/forms/:intakeSubmissionId",
  SOURCING_FORM_DETAILS_TAB: "/sourcing/forms/:intakeSubmissionId/:tab",
  DOCUMENTS: "/documents",
  DOCUMENT_DETAILS: "/documents/:documentId",
  ADD_DOCUMENTS: "/documents/add-new",
  EDIT_DOCUMENT: "/documents/:documentId/edit",
  INTAKE_REQUESTS: "/intake-requests",
  INTAKE_REQUESTS_FOR_CATEGORY: "/intake-requests/:intakeCategoryId",
  NEW_INTAKE_REQUEST_SELECTION: "/intake-requests/new",
  NEW_INTAKE_REQUEST: "/intake-requests/:categoryId/new",
  EDIT_INTAKE_REQUEST: "/intake-request/:categoryId/:intakeSubmissionId/edit",
  DUPLICATE_INTAKE_REQUEST:
    "/intake-request/:categoryId/:intakeSubmissionId/duplicate",
  INTAKE_REQUEST_DETAILS: "/intake-request/:intakeSubmissionId",
  INTAKE_REQUEST_DETAILS_TAB: "/intake-request/:intakeSubmissionId/:tab",
  PURCHASE_ORDERS: "/purchase-orders",
  PURCHASE_ORDER_DETAILS: "/purchase-orders/:purchaseOrderId",
  INTAKE_REQUEST_SETTINGS: "/settings/intake-categories",
  SOURCING_SETTINGS: "/settings/sourcing",
  SOURCING_SETTINGS_CATEGORY_EDIT_FORM:
    "/settings/sourcing-categories/:categoryId/form",
  SOURCING_SETTINGS_EDIT_WORKFLOWS:
    "/settings/sourcing-categories/:categoryId/workflows",
  SOURCING_SETTINGS_EDIT_WORKFLOW:
    "/settings/sourcing-categories/:categoryId/workflows/:workflowId",
  SOURCING_SETTINGS_EDIT_ADVANCED:
    "/settings/sourcing-categories/:categoryId/advanced",
  VENDOR_MANAGEMENT_SETTINGS: "/settings/vendor-management",
  VENDOR_MANAGEMENT_SETTINGS_CUSTOM_FIELDS:
    "/settings/vendor-management/fields",
  VENDOR_MANAGEMENT_SETTINGS_CUSTOM_COLUMNS:
    "/settings/vendor-management/columns",
  INTAKE_REQUEST_SETTINGS_CATEGORY_EDIT_FORM:
    "/settings/intake-categories/:categoryId/form",
  VENDOR_INTAKE_REQUEST_SETTINGS_CATEGORY_EDIT_FORM:
    "/settings/vendor-intake-categories/:categoryId/form",
  VENDOR_INTAKE_REQUEST_SETTINGS_CATEGORY_EDIT_WORKFLOWS:
    "/settings/vendor-intake-categories/:categoryId/workflows",
  VENDOR_INTAKE_REQUEST_SETTINGS_ADVANCED:
    "/settings/vendor-intake-categories/:categoryId/advanced",
  INTAKE_REQUEST_SETTINGS_CATEGORY_EDIT_WORKFLOWS:
    "/settings/intake-categories/:categoryId/workflows",
  INTAKE_REQUEST_SETTINGS_CATEGORY_EDIT_WORKFLOW:
    "/settings/intake-categories/:categoryId/workflows/:workflowId",
  VENDOR_INTAKE_REQUEST_SETTINGS_CATEGORY_EDIT_WORKFLOW:
    "/settings/vendor-intake-categories/:categoryId/workflows/:workflowId",
  INTAKE_REQUEST_SETTINGS_CATEGORY_EDIT_ADVANCED:
    "/settings/intake-categories/:categoryId/advanced",
  INTAKE_REQUEST_SETTINGS_INTEGRATIONS_EDIT:
    "/settings/intake-categories/:categoryId/integrations",
  SPEND_REQUESTS: "/spend-requests",
  ADD_SPEND_REQUEST: "/spend-requests/add-new",
  SPEND_REQUEST_DETAILS: "/spend-requests/:spendRequestId",
  EDIT_SPEND_REQUEST: "/spend-requests/:spendRequestId/edit",
  DUPLICATE_SPEND_REQUEST: "/spend-requests/duplicate/:spendRequestId",
  MODIFY_SPEND_REQUEST: "/spend-requests/modify/:spendRequestId",
  APPROVALS: "/settings/approvals",
  SPEND_RULES_SIMULATE: "/settings/spend-requests/spend-rules/simulate",
  SPEND_RULE_NEW_CUSTOM_FIELDS:
    "/settings/spend-requests/spend-rules/:ruleSetId/custom-fields",
  SPEND_RULE: "/settings/spend-requests/spend-rules/:ruleSetId",
  SPEND_RULES: "/settings/spend-requests/spend-rules",
  SPEND_CATEGORIES: "/settings/spend-categories",
  REVENUE_CATEGORIES: "/settings/revenue-categories",
  LOCATIONS: "/settings/locations",
  MEMBERS: "/settings/members",
  MEMBER_DETAILS: "/settings/members/:memberId",
  EDIT_MEMBER: "/settings/members/:memberId/edit",
  EMAIL_FORWARDING: "/settings/email-forwarding",
  MANAGE_BUSINESS_UNITS: "/settings/manage-business-units",
  MANAGE_BUSINESS_UNIT: "/settings/manage-business-units/:businessUnitId",
  MANAGE_DEPARTMENTS: "/settings/manage-departments",
  MANAGE_DEPARTMENT: "/settings/manage-departments/:departmentId",
  MANAGE_ENTITIES: "/settings/manage-entities",
  MANAGE_GROUPS: "/settings/manage-groups",
  MANAGE_GROUP: "/settings/manage-groups/:groupId",
  MANAGE_APPROVER_MATRIX: "/settings/manage-approver-matrix",
  MANAGE_APPROVER_MATRIX_EDIT:
    "/settings/manage-approver-matrix/:approverMatrixId",
  MANAGE_API_KEYS: "/settings/api-keys",
  MANAGE_INTEGRATIONS: "/settings/integrations",
  MANAGE_INTEGRATIONS_MAPPINGS: "/settings/integrations/mappings",
  FINANCIAL_INSIGHTS: "/budget-tracking/analysis",
  ACTUALS: "/budget-tracking/actuals",
  ACTUALS_DASHBOARD: "/budget-tracking/actuals",
  ACTUALS_WIZARD: "/budget-tracking/actuals/mappings",
  ACTUALS_LOGIN: "/budget-tracking/actuals/login",
  ACTUALS_SYNC_STATUS: "/budget-tracking/actuals/status",
  PLANS: "/budget-tracking/budgets",
  PLAN_IMPORT: "/budget-tracking/budgets/import",
  PLAN_IMPORT_MAP_DEPARTMENTS:
    "/budget-tracking/budgets/import/map-departments/:planId",
  PLAN_IMPORT_MAP_SPEND_CATEGORIES:
    "/budget-tracking/budgets/import/map-spend-categories/:planId",
  PLAN_IMPORT_MAP_REVENUE_CATEGORIES:
    "/budget-tracking/budgets/import/map-revenue-categories/:planId",
  PLAN_IMPORT_MAP_LOCATIONS:
    "/budget-tracking/budgets/import/map-locations/:planId",
  PLAN_IMPORT_MAP_VENDORS:
    "/budget-tracking/budgets/import/map-vendors/:planId",
  PLAN_IMPORT_MAP_BUSINESS_UNITS:
    "/budget-tracking/budgets/import/map-business-units/:planId",
  PLAN: "/budget-tracking/budgets/:planId",
  EDIT_PLAN: "/budget-tracking/budgets/:planId/edit",
  HEADCOUNT: "/headcount-tracking/:planId",
  HEADCOUNT_IMPORT: "/headcount-tracking/import",
  HEADCOUNT_IMPORT_MAP_DEPARTMENTS:
    "/headcount-tracking/import/map-departments/:planId",
  HEADCOUNT_IMPORT_MAP_LOCATIONS:
    "/headcount-tracking/import/map-locations/:planId",
  HEADCOUNT_ROSTER: "/headcount-tracking/roster",
  HEADCOUNT_INSIGHTS: "/headcount-tracking/insights",
  TRANSACTIONS: "/budget-tracking/actuals/transactions",
  TRANSACTIONS_COMMENTS: "/budget-tracking/actuals/transactions/comments",
  ADD_BILL: "/bills/new",
  MANAGE_HEADCOUNT_DEPARTMENTS:
    "/settings/manage-mappings/headcount/departments",
  MANAGE_HEADCOUNT_LOCATIONS: "/settings/manage-mappings/headcount/locations",
  MANAGE_ACTUALS_MAPPINGS: "/settings/manage-mappings/actuals",
  MANAGE_ACTUALS_MAPPINGS_ERP_LOCATIONS:
    "/settings/manage-mappings/actuals/locations",
  MANAGE_ACTUALS_MAPPINGS_ERP_VENDORS:
    "/settings/manage-mappings/actuals/erp-vendors",
  MANAGE_ACTUALS_MAPPINGS_ERP_DEPARTMENTS:
    "/settings/manage-mappings/actuals/erp-departments",
  MANAGE_ACTUALS_MAPPINGS_ERP_ENTITIES:
    "/settings/manage-mappings/actuals/erp-entities",
  MANAGE_ACTUALS_MAPPINGS_ERP_EXPENSE_ACCOUNTS:
    "/settings/manage-mappings/actuals/erp-expense-accounts",
  MANAGE_ACTUALS_MAPPINGS_ERP_REVENUE_ACCOUNTS:
    "/settings/manage-mappings/actuals/erp-revenue-accounts",
  MANAGE_ACTUALS_MAPPINGS_ERP_CLASSIFICATIONS:
    "/settings/manage-mappings/actuals/erp-classifications",
  MANAGE_PLANS_MAPPINGS: "/settings/manage-mappings/budgets",
  MANAGE_PLANS_MAPPINGS_DEPARTMENTS:
    "/settings/manage-mappings/budgets/departments/:planId",
  MANAGE_PLANS_MAPPINGS_SPEND_CATEGORIES:
    "/settings/manage-mappings/budgets/spend-categories/:planId",
  MANAGE_PLANS_MAPPINGS_REVENUE_CATEGORIES:
    "/settings/manage-mappings/budgets/revenue-categories/:planId",
  MANAGE_PLANS_MAPPINGS_LOCATIONS:
    "/settings/manage-mappings/budgets/locations/:planId",
  MANAGE_PLANS_MAPPINGS_VENDORS:
    "/settings/manage-mappings/budgets/vendors/:planId",
  MANAGE_PLANS_MAPPINGS_BUSINESS_UNITS:
    "/settings/manage-mappings/budgets/business-units/:planId",
  MANAGE_PAYMENTS_SETTINGS: "/settings/payments",
  MANAGE_PAYMENTS_ONBOARDING: "/settings/payments/onboarding",
  MANAGE_PAYMENTS_BILL_RULE: "/settings/payments/bill-rules/:ruleSetId",
  BILL_RULES_SIMULATE: "/settings/payments/bill-rules/simulate",
  MANAGE_PAYMENTS_BILL_RULES: "/settings/payments/bill-rules",
  MANAGE_PAYMENT_DETAILS_APPROVERS:
    "/settings/payments/payment-details-approvers",
  NOTIFICATION_SETTINGS: "/settings/notifications",
  NOTIFICATION_SETTINGS_REMINDERS: "/settings/notifications/reminders",
  NOTIFICATION_SETTINGS_VENDORS: "/settings/notifications/vendors",
  USER_NOTIFICATION_SETTINGS: "/user/settings/notifications",
  USER_DELEGATE_APPROVER_SETTINGS: "/user/settings/delegate-approvers",
  PAYMENTS: "/payments",
  PAYMENTS_TRANSACTIONS: "/payments/transactions",
  BILL_PAYMENT_DETAILS: "/payments/bill-payments/:billPaymentId",
  PAYMENTS_INVOICES: "/payments/invoices",
  BILLS: "/payments/bills",
  NEW_BILL: "/payments/bills/new",
  EDIT_BILL: "/payments/bills/edit/:billId",
  NEW_BILL_FROM_INVOICE: "/payments/bills/new/:invoiceId",
  BILL_DETAILS: "/payments/bills/:billId",
  BILL_DETAILS_TAB: "/payments/bills/:billId/:tab",
  UNSYNCED_LEDGER_ENTRIES: "/payments/ledger-entries/unsynced",
  SYNCED_LEDGER_ENTRIES: "/payments/ledger-entries/synced",
  ERRORED_LEDGER_ENTRIES: "/payments/ledger-entries/errored",
  REPORTS: "/reports",
  REQUEST_ANALYTICS: "/reports/request-analytics",
  SPEND_REVIEW_REPORT: "/reports/spend-review",
  SUPER_ADMIN: "/super-admin",
  VENDOR_PORTAL_LOGIN: "/v/login",
  VENDOR_PORTAL_HOME: "/v/home",
  VENDOR_PORTAL_COMPANY_PROFILE: "/v/company-profile",
  VENDOR_PORTAL_MEMBERS: "/v/members",
  VENDOR_PORTAL_CUSTOMERS: "/v/customers",
  VENDOR_PORTAL_PAYMENTS: "/v/payments",
  VENDOR_PORTAL_FORMS: "/v/forms",
  VENDOR_PORTAL_FORM_EDIT: "/v/forms/:intakeSubmissionId/edit",
  VENDOR_PORTAL_FORM_DETAILS: "/v/forms/:intakeSubmissionId",
  VENDOR_PORTAL_COMPANY_SELECTION: "/v/company-selection",
  PUBLIC_SOURCING_FORM: "/public/sourcing/:companyId/:categoryId",
  NOT_FOUND: "/404",
} as const;

export type Page = (typeof Page)[keyof typeof Page];

type Pages = typeof Page;

type RouteWithWildcard2<S extends string> =
  S extends `${string}/:${infer WildCard}/${infer Rest}`
    ? {
        [key in WildCard]: string;
      } & RouteWithWildcard2<`/${Rest}`>
    : S extends `${string}/:${infer WildCard}`
    ? {
        [key in WildCard]: string;
      }
    : S extends `:${infer Wildcard}`
    ? {
        [key in Wildcard]: string;
      }
    : // eslint-disable-next-line @typescript-eslint/ban-types
      {};

export function generatePath<K extends keyof Pages, V extends Pages[K]>(
  route: V,
  param: RouteWithWildcard2<V>,
) {
  return reactRouterDomGeneratePath(route, param);
}

export function pathIsPage(path: string, page: Page): boolean {
  return !!matchPath(page, path);
}
